import React, { useEffect, useRef } from 'react'
import { useTheme } from 'styled-components'

import PluginPortal from 'live/components/ui/PluginPortal'

import { Icon } from '../../utils'
import { ModalClose, ModalContent, ModalOverlay } from './styles'

interface Props {
    height?: number
    width?: number
    border?: string
    background?: string
    onClose: () => void
    style?: React.CSSProperties
    backdropClose?: boolean
}

export const Portal: React.FC<Props> = props => {
    const { children, height, width, border, background, style, onClose, backdropClose = true } = props

    const overlayRef = useRef<HTMLDivElement>(null)
    const theme = useTheme()

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (overlayRef.current) {
            if (e.target === overlayRef.current && backdropClose) {
                onClose()
            }
        }
    }

    useEffect(() => {
        const handleEscape = (e: KeyboardEvent): void => {
            if (e.key === 'Escape') {
                onClose()
            }
        }

        document.addEventListener('keydown', handleEscape)

        return () => document.removeEventListener('keydown', handleEscape)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <PluginPortal>
            <ModalOverlay ref={overlayRef} onClick={handleOverlayClick}>
                <ModalContent
                    height={height ?? 423}
                    width={width ?? 552}
                    border={border}
                    background={background}
                    style={style}
                >
                    <ModalClose onClick={onClose}>
                        <Icon
                            type="closeModal"
                            withG={false}
                            color={theme['gray-800']}
                            auxliarColor={theme['gray-200']}
                            style={{ transform: 'scale(1.5)' }}
                        />
                    </ModalClose>
                    {children}
                </ModalContent>
            </ModalOverlay>
        </PluginPortal>
    )
}
